import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { balance_filters, balance_headers } from "./config";

const BalanceList = () => {

  return (
    <Table tableId="bills/balances" title="Sold Wig" icon={InventoryRoundedIcon} headers={balance_headers} filters={balance_filters} defaultSort="-sold_date" idKey="bill_line_item_id" fieldsToSearch={["Vendor", "Customer"]} additionalCollections="view_bill_by_wig_balances:customer_name,view_bill_by_wig_balances:wig_id" createNew={false} edit={false} trash={false} viewUrl="inventory" viewId="inventory_id" disableActions={true} exportCsv={true} />
  );
};

export default BalanceList;